.<template>
  <div>
    <Header />

    <section class="container container-space-y-m">
      <div class="intro">
        <div class="intro-title">公司简介</div>
        <p class="intro-content">极汇互动(广东)信息科技有限公司是一家多元化网络信息技术公司,全程网络营销服务提供商，公司以"系统开发"和“短信服务”为主导，以技术应用为基础，着"以诚为本、以信立业"的服务宗旨，为企业提供互联网解决方案。</p>
      </div>
    </section>

    <section class="container-space-b-s">
      <div class="container">
        <div class="d-flex">

          <div class="flex-shrink-0 mr-5">
            <device-browser shadow="none">
              <baidu-map class="baidu-map-view"
                         :scroll-wheel-zoom="true"
                         @ready="mapReady">
                <!-- bm-marker 就是标注点 定位在point的经纬度上 跳动的动画 -->
                <bm-marker :position="point"
                           animation="BMAP_ANIMATION_BOUNCE"
                           @click="showInfoWindow = true">
                </bm-marker>
                <bm-info-window title="极汇互动(广东)信息科技有限公司"
                                :width="350"
                                :position="point"
                                :show="showInfoWindow"
                                @close="showInfoWindow = false">
                  <p>地址：广东省广州市黄埔区联和街道广汕3路31号</p>
                  <p>联系电话：020-86574220</p>
                </bm-info-window>
              </baidu-map>
            </device-browser>
          </div>

          <div class="flex-grow-1 contact-address">
            <div class="mb-5">
              <h3 class="mb-2"><i class="contact-address-title"></i> 办公地址/Office Address</h3>
              <p>广东省广州市黄埔区联和街道广汕3路31号</p>
            </div>
            <div class="contact-address-item">
              <h3 class="mb-2"><i class="fa fa-phone"></i>联系方式/Phone</h3>
              <p>服务热线：020-86574220</p>
            </div>
          </div>

        </div>
      </div>
    </section>

    <BannerRegistration />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
import DeviceBrowser from '@/components/device-browser'
import BannerRegistration from '@/components/banner-registration'
export default {
  name: 'ContactUs',
  components: {
    Header,
    Footer,
    DeviceBrowser,
    BannerRegistration
  },
  data () {
    return {
      point: {},
      showInfoWindow: true // 显示信息窗口
    }
  },

  methods: {
    mapReady ({ BMap, map }) {
      // 选择一个经纬度作为中心点
      this.point = new BMap.Point(113.44308, 23.194689)
      map.centerAndZoom(this.point, 17)
    }

  }
}
</script>

<style lang="scss" scoped>
.contact-address {
  background: #051429;
  padding: 40px 35px;

  h3 {
    color: #fff;
  }

  p {
    color: #c5c5c5;
  }
}
.contact-address-line {
  width: 100%;
  height: 1px;
  background-color: #fff;
}

.intro {
  position: relative;

  article {
    max-width: 800px;
    padding: 20px;
    background-color: #fff;
    border-radius: 1rem;
    box-shadow: 0px 0px 40px rgba(29, 58, 83, 0.15) !important;
    p {
      font-size: 1rem;
      text-indent: 2rem;
    }
  }
}

.intro-title {
  font-weight: 600;
  font-size: 36px;
  color: #000;
  line-height: 47px;
  text-align: center;
  margin-bottom: 18px;
}

.intro-content {
  line-height: 25px;
  font-size: 18px;
  color: #4c4c4c;
}

.baidu-map-view {
  width: 100%;
  height: calc(100vh - 390px);
}
</style>
